import { registerToolkitObjectType } from 'client/components/toolkit/objects/registerToolkitObjectType';

export interface DeskBookmark {
  name: string;
  url: string;
}

export const BookmarkToolkitObject = registerToolkitObjectType<{}>('bookmark');
